import { Container, CssBaseline } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState, useMemo } from "react";
import Scrollbar from "react-scrollbars-custom";
import AppBarBasic from "../layout/AppBar";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Skeleton,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import axios from "axios";
import { API_URL } from "../../utils/setApiUrl";
import ServiceCleaningService from "../../services/ServiceCleaningService";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import SosIcon from "@mui/icons-material/Sos";
import Alert from "@material-ui/lab/Alert";
import CachedIcon from "@mui/icons-material/Cached";
import DeviceService from "../../services/DeviceService";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import OpacityIcon from "@mui/icons-material/Opacity";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import WebAppConfigService from "../../services/WebAppConfigService";
import { FixedSizeGrid } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const drawerWidth = 280;

const themeColors = createTheme({
  palette: {
    primary: {
      main: "#003d4d",
    },
    secondary: {
      main: "#8adc39",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  "@global": {
    "@keyframes flashColor": {
      "0%, 100%": { backgroundColor: "#bb2124" }, // Solid red color
      "50%": { backgroundColor: "#e57373" }, // Lighter red for the flash effect
    },
    "@keyframes flashIcon": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.5 },
    },
  },
  flashingIcon: {
    animation: "$flashIcon 0.5s infinite",
  },
  root: {
    display: "flex",
  },
  form: (props) => ({
    "& .MuiTextField-root": {
      // marginTop: theme.spacing(1),
      width: "100%",
    },
    "& .MuiButton-root": {
      marginTop: theme.spacing(1),
    },
    "& .MuiAlert-root": {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(1),
      },
    },
  }),
  toolbar: {
    backgroundColor: "white",
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    whiteSpace: "nowrap",
    background: "linear-gradient(#006987 0%, #003544 100%)",
    border: "none",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  card: {
    borderRadius: "12px",
  },
  flashingCard: {
    animation: "$flashColor 1s infinite", // Flashing animation for red background
  },
  cardGradient: {
    background: "linear-gradient(#006987 0%, #003544 100%)", // Default gradient background
  },
  logo: {
    "& .logo-icon": {
      width: "170px",
      margin: theme.spacing(2.5, 6),
      transition: theme.transitions.create(["width"], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
  },
  item: (props) => ({
    height: 40,
    /* width: 'calc(100% - 16px)', */
    borderRadius: "0",
    /* paddingRight: 12, */
    paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
    "&.active": {
      backgroundColor: "#8adc39",
      color: `${theme.palette.secondary.contrastText}!important`,
      pointerEvents: "none",
      transition: "border-radius .15s cubic-bezier(0.4,0.0,0.2,1)",
      "& .list-item-text-primary": {
        color: "inherit",
      },
      "& .list-item-icon": {
        color: theme.palette.text.icon,
      },
    },
    "& .list-item-icon": {
      marginRight: 16,
      color: theme.palette.text.icon,
    },
    "& .list-item-text": {},
    color: theme.palette.text.icon,
    cursor: "pointer",
    textDecoration: "none!important",
  }),
  itemtext: {
    fontSize: "0.8rem",
  },
  icon: {
    color: "white",
  },
  nested: {
    fontSize: "0.9rem",
    height: 40,
    paddingLeft: theme.spacing(9),
  },
  blueBar: {
    backgroundColor: "#003d4d",
    alignContent: "center",
    verticalAlign: "middle",
    flex: "auto",
    textAlign: "center",
    fontSize: "1.4rem",
    fontWeight: "400",
    color: "white",
    height: "8vh",
    padding: "1%",
  },
  cardAction: {
    width: "100%",
  },
  statusIndicator: {
    position: "absolute",
    top: 3,
    left: 3,
    width: 12,
    height: 12,
    borderRadius: "50%",
    zIndex: 1,
  },
  online: {
    color: "#4CBB17", // Green color for online status
  },
  offline: {
    color: "#bb2124", // Red color for offline status
  },
}));

export default function Rooms(props) {
  const classes = useStyles();
  const [waterleakDevicesEnabled, setWaterleakDevicesEnabled] = useState(() => {
    try {
      const stored = localStorage.getItem("waterleakDevicesConfig");
      return stored === null ? false : JSON.parse(stored);
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return false;
    }
  });

  // Initialize state variables from localStorage
  const [lightSensorsEnabled, setLightSensorsEnabled] = useState(() => {
    try {
      const stored = localStorage.getItem("lightSensorsConfig");
      return stored === null ? false : JSON.parse(stored);
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return false;
    }
  });

  const [sosSystemEnabled, setSosSystemEnabled] = useState(() => {
    try {
      const stored = localStorage.getItem("sosSystemConfig");
      return stored === null ? false : JSON.parse(stored);
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return false;
    }
  });

  const [doorStatusTrackingEnabled, setDoorStatusTrackingEnabled] = useState(
    () => {
      try {
        const stored = localStorage.getItem("doorStatusTrackingConfig");
        return stored === null ? false : JSON.parse(stored);
      } catch (error) {
        console.error("Error reading from localStorage:", error);
        return false;
      }
    }
  );

  // Fetch webconfig settings
  useEffect(() => {
    WebAppConfigService.getAll()
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const config = response.data[0]; // Assuming the first config is the active one

          // Update state variables
          setLightSensorsEnabled(config.light_sensors);
          setSosSystemEnabled(config.sos_system);
          setDoorStatusTrackingEnabled(config.door_status_tracking);
          setWaterleakDevicesEnabled(config.waterleak_devices);

          // Store in localStorage
          try {
            localStorage.setItem(
              "lightSensorsConfig",
              JSON.stringify(config.light_sensors)
            );
            localStorage.setItem(
              "sosSystemConfig",
              JSON.stringify(config.sos_system)
            );
            localStorage.setItem(
              "doorStatusTrackingConfig",
              JSON.stringify(config.door_status_tracking)
            );
            localStorage.setItem(
              "waterleakDevicesConfig",
              JSON.stringify(config.waterleak_devices)
            );
          } catch (error) {
            console.error("Error writing to localStorage:", error);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching web config:", error);
        // Set defaults if fetch fails
        setLightSensorsEnabled(false);
        setSosSystemEnabled(false);
        setDoorStatusTrackingEnabled(false);
        setWaterleakDevicesEnabled(false);

        // Store defaults in localStorage
        try {
          localStorage.setItem("lightSensorsConfig", "false");
          localStorage.setItem("sosSystemConfig", "false");
          localStorage.setItem("doorStatusTrackingConfig", "false");
          localStorage.setItem("waterleakDevicesConfig", "false");
        } catch (error) {
          console.error("Error writing to localStorage:", error);
        }
      });
  }, []);

  const [disabledButtons, setDisabledButtons] = useState({}); // State to track disabled buttons per room
  const [timeLeft, setTimeLeft] = useState({});

  // Helper function to calculate the time left in seconds
  const calculateTimeLeft = (disableUntil) => {
    const now = new Date().getTime();
    return Math.max(0, Math.floor((disableUntil - now) / 1000)); // Return time left in seconds
  };

  useEffect(() => {
    const storedDisabledButtons =
      JSON.parse(localStorage.getItem("disabledButtons")) || {};
    const now = new Date().getTime();

    // Clean up any buttons that should no longer be disabled
    const updatedDisabledButtons = Object.keys(storedDisabledButtons).reduce(
      (acc, roomId) => {
        if (storedDisabledButtons[roomId] > now) {
          acc[roomId] = storedDisabledButtons[roomId];
        }
        return acc;
      },
      {}
    );

    setDisabledButtons(updatedDisabledButtons);

    // Set up an interval to update the countdown timer every second
    const intervalId = setInterval(() => {
      const newTimeLeft = {};
      Object.keys(updatedDisabledButtons).forEach((roomId) => {
        const disableUntil = updatedDisabledButtons[roomId];
        newTimeLeft[roomId] = calculateTimeLeft(disableUntil);
      });

      setTimeLeft(newTimeLeft);
    }, 1000);

    // Clean up the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const client = axios.create({
    baseURL: API_URL,
  });

  // * Service Cleaning API call
  const [loading, setLoading] = useState(true);
  const [rooms, setRooms] = useState([]);

  // ! SOS AUDIO STATE
  const [audio, setAudio] = useState(null);

  useEffect(() => {
    // Only set up SOS detection if SOS system is enabled
    if (!sosSystemEnabled) return;

    const retrieveRooms = () => {
      const checkSosStatus = async () => {
        try {
          const response = await DeviceService.adminAllRooms();
          const locData = JSON.parse(localStorage.getItem("loc"));
          const loc = locData.id !== undefined ? locData.id : locData;

          // Filter rooms based on location
          let filteredRooms;
          if (loc === "all") {
            filteredRooms = response.data;
          } else {
            const locIds = (Array.isArray(loc) ? loc : [loc]).map(Number);
            filteredRooms = response.data.filter(
              (room) => locIds.includes(Number(room.location))
            );
          }

          setRooms(filteredRooms);
          setLoading(false);

          // Check for active SOS
          const sosActive = filteredRooms.some((room) => room.sos_button);
          if (sosActive) {
            const newAudio = new Audio("./sos.mp3");
            newAudio.play().catch((error) => {
              console.error("Audio playback failed:", error);
            });
            setAudio(newAudio);
          }
        } catch (e) {
          setErrorMessages(["Cannot load rooms data"]);
          setIserror(true);
        }
      };

      checkSosStatus();
    };

    retrieveRooms(); // Call once initially
    const intervalId = setInterval(retrieveRooms, 10000); // Set interval to retrieve rooms every 10 seconds

    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
  }, [sosSystemEnabled]); // Add sosSystemEnabled as a dependency

  // Separate useEffect to fetch rooms data when SOS system is disabled
  useEffect(() => {
    // Only run this effect if SOS system is disabled
    if (sosSystemEnabled) return;

    const fetchRoomsData = async () => {
      try {
        const response = await DeviceService.adminAllRooms();
        const locData = JSON.parse(localStorage.getItem("loc"));

        // Filter rooms based on location
        let filteredRooms;
        if (locData.id === "all") {
          filteredRooms = response.data;
        } else {
          filteredRooms = response.data.filter(
            (room) => room.location === locData.id
          );
        }

        setRooms(filteredRooms);
        setLoading(false);
      } catch (e) {
        setErrorMessages(["Cannot load rooms data"]);
        setIserror(true);
      }
    };

    fetchRoomsData(); // Call once initially
    const intervalId = setInterval(fetchRoomsData, 10000); // Set interval to retrieve rooms every 10 seconds

    return () => clearInterval(intervalId); // Cleanup the interval on component unmounts
  }, [sosSystemEnabled]);

  const handleSosButtonClick = async (room) => {
    // Only process if SOS system is enabled
    if (!sosSystemEnabled) return;

    try {
      await client.post(`/stop_panic`, {
        device: room.mac,
      });

      await DeviceService.updateByMac(room.mac, {
        sos_button: false,
      });

      setRooms((prevRooms) =>
        prevRooms.map((r) =>
          r.id === room.id ? { ...r, sos_button: false } : r
        )
      );

      if (audio) {
        audio.pause();
        audio.currentTime = 0; // Reset the audio to the beginning
        setAudio(null);
      }
    } catch (error) {
      console.error("Failed to update sos_button status:", error);
    }
  };

  const handleEnergyButtonClick = async (room) => {
    // Only process if light sensors are enabled
    if (!lightSensorsEnabled) return;

    try {
      const newEnergyStatus = !room.energy_status;
      await DeviceService.updateByMac(room.mac, {
        energy_status: newEnergyStatus,
      });

      setRooms((prevRooms) =>
        prevRooms.map((r) =>
          r.id === room.id ? { ...r, energy_status: newEnergyStatus } : r
        )
      );
    } catch (error) {
      console.error("Failed to update energy_status:", error);
    }
  };

  const skeletonArray = Array(50).fill("");

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  // * Service Cleaning API call end

  // * Sidebar SubMenu Function

  const [open, setOpen] = useState(true);
  const handleClick = () => {
    setOpen(!open);
  };

  const [openCard, setOpenCard] = React.useState(false);
  const [openSupportCard, setOpenSupportCard] = React.useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [roomNumber, setRoomNumber] = React.useState([]);
  const [roomStatus, setRoomStatus] = React.useState([]);
  const [roomMessage, setRoomMessage] = React.useState("");
  const handleCardOpen = (room, e) => {
    setOpenCard(true);
    setRoomNumber(room.room);
    setRoomStatus(room.status);
    setRoomMessage(room.message);
  };

  const handleSupportCardOpen = (room, e) => {
    setOpenSupportCard(true);
    setRoomNumber(room.room);
  };

  const handleCardClose = () => {
    setOpenCard(false);
    setOpenSupportCard(false);
  };

  const DialogComponent = (room) => {
    const initialRoomMessageState = {
      message: "",
    };
    const [currentRoomMessage, setCurrentRoomMessage] = useState(
      initialRoomMessageState
    );

    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setCurrentRoomMessage({ ...currentRoomMessage, [name]: value });
    };

    const [message, setMessage] = useState("");

    const handleSubmit = (event) => {
      event.preventDefault();
      ServiceCleaningService.update(roomNumber, {
        message: currentRoomMessage.message,
      })
        .then((response) => {
          console.log(response.data);
          setMessage(
            <Alert severity="success">Коментара беше добавен успешно!</Alert>
          );
          setTimeout(() => {
            setRoomMessage(currentRoomMessage.message);
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    return (
      <ThemeProvider theme={themeColors}>
        <Dialog
          open={openCard}
          onClose={handleCardClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={"sm"}
          fullScreen={fullScreen}
        >
          <DialogTitle id="alert-dialog-title">
            Стая: {roomNumber} |
            {(() => {
              if (roomStatus === 1) {
                return " Заредена";
              } else if (roomStatus === 2) {
                return " Незаредена";
              } else if (roomStatus === 3) {
                return " За Ремонт";
              }
              return null;
            })()}
            <IconButton
              aria-label="close"
              onClick={handleCardClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers style={{ padding: "30px 25px" }}>
            <Grid container spacing={8}>
              <Grid item>
                {message}
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div>
                    <TextField
                      required
                      id="outlined-required message"
                      type="text"
                      multiline
                      rows={4}
                      label="Коментар"
                      variant="outlined"
                      name="message"
                      value={currentRoomMessage.message}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                    />
                  </div>
                  <Button type="submit" variant="contained" color="primary">
                    Запиши
                  </Button>
                </form>
              </Grid>
              <Grid item>
                <DialogContentText>
                  <b>Коментар</b>:
                </DialogContentText>
                <DialogContentText>{roomMessage}</DialogContentText>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCardClose} color="neutral">
              Затвори
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  const SupportDialogComponent = (room) => {
    const initialRoomMessageState = {
      message: "",
    };
    const [currentRoomMessage, setCurrentRoomMessage] = useState(
      initialRoomMessageState
    );

    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setCurrentRoomMessage({ ...currentRoomMessage, [name]: value });
    };

    const [message, setMessage] = useState("");

    const handleSubmit = (event) => {
      event.preventDefault();
      ServiceCleaningService.update(roomNumber, {
        message: currentRoomMessage.message,
      })
        .then((response) => {
          console.log(response.data);
          setMessage(
            <Alert severity="success">Коментара беше добавен успешно!</Alert>
          );
          setTimeout(() => {
            setRoomMessage(currentRoomMessage.message);
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    return (
      <ThemeProvider theme={themeColors}>
        <Dialog
          open={openSupportCard}
          onClose={handleCardClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={"xs"}
          fullScreen={fullScreen}
        >
          <DialogTitle id="alert-dialog-title">
            Поддръжка и Липси | Стая: {roomNumber}
            <IconButton
              aria-label="close"
              onClick={handleCardClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            style={{ padding: "30px 25px", textAlign: "center" }}
          >
            {message}
            <img
              src="https://system.biodit.com/form-request.png"
              style={{ width: "70%", height: "95%" }}
            />
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCardClose} color="neutral">
              Затвори
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  // Snackbars Start
  const [snackbars, setSnackbars] = useState([]);

  const handleCloseSnackbar = (id) => {
    setSnackbars((prevSnackbars) =>
      prevSnackbars.filter((snackbar) => snackbar.id !== id)
    );
  };

  const handleShowSnackbar = (message, severity) => {
    const id = new Date().getTime(); // Unique ID for each snackbar
    const newSnackbar = {
      id,
      message,
      severity,
      position: snackbars.length * 55,
    };

    setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);
  };
  //Snackbars End

  // * Functionality for restarting devices START
  const handleRestartButtonClick = async (room) => {
    const { mac, id } = room;

    try {
      const res = await client.post("/restartDevice", { mac });

      if (res.status === 200) {
        const now = new Date().getTime();
        const disableUntil = now + 2 * 60 * 1000; // Disable for 2 minutes (120,000 ms)

        // Update state and localStorage for the specific room's button
        const updatedDisabledButtons = {
          ...disabledButtons,
          [id]: disableUntil,
        };
        setDisabledButtons(updatedDisabledButtons);
        localStorage.setItem(
          "disabledButtons",
          JSON.stringify(updatedDisabledButtons)
        );

        // Start a countdown for the tooltip
        setTimeLeft((prevTimeLeft) => ({
          ...prevTimeLeft,
          [id]: calculateTimeLeft(disableUntil),
        }));

        // Automatically re-enable after 2 minutes
        setTimeout(() => {
          const newDisabledButtons = { ...updatedDisabledButtons };
          delete newDisabledButtons[id];
          setDisabledButtons(newDisabledButtons);
          localStorage.setItem(
            "disabledButtons",
            JSON.stringify(newDisabledButtons)
          );
        }, 2 * 60 * 1000);
      }
    } catch (err) {
      console.error("Error restarting the device:", err);
    }
  };
  // * Functionality for restarting devices END

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBarBasic />
      <main className={classes.content}>
        <Scrollbar id="RSC-Example" style={{ width: "100%", height: "100%" }}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="xl" className={classes.container}>
            {snackbars
              .slice()
              .reverse()
              .map((snackbar, index) => (
                <Snackbar
                  key={snackbar.id}
                  open={true}
                  autoHideDuration={5000}
                  onClose={() => handleCloseSnackbar(snackbar.id)}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  style={{ top: `${10 + index * 55}px` }}
                >
                  <Alert
                    elevation={6}
                    variant="filled"
                    severity={snackbar.severity}
                    onClose={() => handleCloseSnackbar(snackbar.id)}
                  >
                    {snackbar.message}
                  </Alert>
                </Snackbar>
              ))}

            {loading ? (
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                spacing={{ xs: 2, md: 1 }}
                sx={{ width: "100%" }}
              >
                {skeletonArray.map((item, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    key={index}
                    sx={{ width: "100%" }}
                  >
                    <Card className={classes.card} sx={{ height: "100%" }}>
                      <CardContent style={{ paddingTop: 20, marginBottom: 5 }}>
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              animation="wave"
                              height={25}
                              width={25}
                            />
                            <Skeleton
                              variant="circular"
                              animation="wave"
                              height={25}
                              width={25}
                            />
                            <Skeleton
                              variant="circular"
                              animation="wave"
                              height={25}
                              width={25}
                            />
                          </div>
                        ) : (
                          "Body"
                        )}
                      </CardContent>
                      <CardActions
                        className="justify-center"
                        style={{
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "4px",
                        }}
                      >
                        {loading ? (
                          <Stack
                            direction="row"
                            divider={
                              <Divider orientation="vertical" flexItem />
                            }
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ gap: "0.9rem" }}
                          >
                            <Skeleton
                              animation="wave"
                              variant="circular"
                              width={20}
                              height={20}
                            />
                            <Skeleton
                              animation="wave"
                              variant="circular"
                              width={20}
                              height={20}
                            />
                            <Skeleton
                              animation="wave"
                              variant="circular"
                              width={20}
                              height={20}
                            />
                            <Skeleton
                              animation="wave"
                              variant="circular"
                              width={20}
                              height={20}
                            />
                            <Skeleton
                              animation="wave"
                              variant="circular"
                              width={20}
                              height={20}
                            />
                          </Stack>
                        ) : (
                          "Actions"
                        )}
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <div
                style={{
                  height: "calc(100vh - 120px)",
                  width: "100%",
                  overflow: "auto",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  sx={{ width: "100%", padding: "8px" }}
                >
                  {rooms.map((room) => {
                    const isDisabled =
                      disabledButtons[room.id] &&
                      new Date().getTime() < disabledButtons[room.id];
                    const timeRemaining = timeLeft[room.id];

                    return (
                      <Grid item xs={6} sm={4} md={2.4} key={room.id}>
                        <Card
                          className={`${classes.card} ${
                            room.sos_button && sosSystemEnabled
                              ? classes.flashingCard
                              : classes.cardGradient
                          }`}
                          style={{
                            position: "relative",
                            height: "auto",
                            ...(room.sos_button && sosSystemEnabled
                              ? { backgroundColor: "#bb2124" }
                              : {}),
                          }}
                          onClick={(e) => handleCardOpen(room, e)}
                        >
                          <CardContent style={{ paddingBottom: "8px" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                marginBottom: "0",
                                padding: "0 4px",
                              }}
                            >
                              {/* Energy Status Button - Only show if light_sensors is enabled */}
                              {lightSensorsEnabled && (
                                <Tooltip
                                  title={
                                    room.energy_status
                                      ? "Тока в стаята е включен"
                                      : "Тока в стаята е изключен"
                                  }
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: "1rem",
                                        backgroundColor: "#ccc",
                                        color: "black",
                                      },
                                    },
                                  }}
                                >
                                  <span>
                                    <IconButton
                                      aria-label="energy_status"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEnergyButtonClick(room);
                                      }}
                                    >
                                      <WbSunnyIcon
                                        style={{
                                          color: room.energy_status
                                            ? "#FFD700"
                                            : "#ccc",
                                        }}
                                      />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                              <Typography
                                variant="h5"
                                style={{ color: "#ffffff" }}
                              >
                                {room.name}
                              </Typography>
                              <Tooltip
                                title={
                                  isDisabled
                                    ? timeRemaining !== undefined
                                      ? `Бутона ще бъде отново активен след ${timeRemaining} секунди. Моля изчакайте...`
                                      : "Бутона ще бъде отново активен след 2 минути." // Fallback message while waiting for the first calculation
                                    : "Рестарт"
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "1rem",
                                      backgroundColor: "#ccc",
                                      color: "black",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  {/* Restart Button */}
                                  <IconButton
                                    key={room.id}
                                    aria-label="restart"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRestartButtonClick(room);
                                    }}
                                    disabled={isDisabled}
                                  >
                                    <RestartAltIcon
                                      style={{
                                        color: isDisabled ? "#ccc" : "#ffffff",
                                      }}
                                    />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </div>

                            {/* Continue with the rest of your card content */}
                            {/* I'm preserving the existing card content structure but not including all of it for brevity */}
                            {/* You should include all the original card content here */}

                            {/* Add the rest of your card content here */}
                          </CardContent>
                          {/* Include your CardActions here */}
                          <CardActions
                            className="justify-center"
                            style={{
                              backgroundColor: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "0",
                              marginTop: "0",
                            }}
                          >
                            <Stack
                              direction="row"
                              divider={
                                <Divider orientation="vertical" flexItem />
                              }
                              justifyContent="space-around"
                              alignItems="center"
                              sx={{ gap: "0.10rem" }}
                            >
                              <Tooltip
                                title={
                                  room.clean_button
                                    ? "Има заявка за почистване"
                                    : "Няма заявка за почистване"
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "1rem",
                                      backgroundColor: "#ccc",
                                      color: "black",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  <IconButton
                                    aria-label="clean"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {room.clean_button ? (
                                      <CleaningServicesIcon
                                        style={{ color: "#1e90ff" }}
                                      />
                                    ) : (
                                      <CleaningServicesIcon
                                        style={{ color: "#ccc" }}
                                      />
                                    )}
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip
                                title={
                                  room.dnd_button
                                    ? "DND е включен"
                                    : "DND е изключен"
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "1rem",
                                      backgroundColor: "#ccc",
                                      color: "black",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  <IconButton
                                    aria-label="dnd"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {room.dnd_button ? (
                                      <DoNotDisturbOnIcon
                                        style={{ color: "#bb2124" }}
                                      />
                                    ) : (
                                      <DoNotDisturbOnIcon
                                        style={{ color: "#ccc" }}
                                      />
                                    )}
                                  </IconButton>
                                </span>
                              </Tooltip>

                              {/* SOS Button - Only show if sos_system is enabled */}
                              {sosSystemEnabled && (
                                <Tooltip
                                  title={
                                    room.sos_button
                                      ? "SOS е активиран"
                                      : "Няма включен SOS"
                                  }
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: "1rem",
                                        backgroundColor: "#ccc",
                                        color: "black",
                                      },
                                    },
                                  }}
                                >
                                  <span>
                                    <IconButton
                                      aria-label="sos"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSosButtonClick(room);
                                      }}
                                    >
                                      {room.sos_button ? (
                                        <SosIcon
                                          className={classes.flashingIcon}
                                          style={{
                                            color: "#bb2124",
                                          }}
                                        />
                                      ) : (
                                        <SosIcon style={{ color: "#ccc" }} />
                                      )}
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                              {/* Door Status - Only show if door_status_tracking is enabled */}
                              {doorStatusTrackingEnabled && (
                                <Tooltip
                                  title={
                                    room.door_open
                                      ? "Вратата е отворена"
                                      : "Вратата е затворена"
                                  }
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: "1rem",
                                        backgroundColor: "#ccc",
                                        color: "black",
                                      },
                                    },
                                  }}
                                >
                                  <span>
                                    <IconButton
                                      aria-label="door_open"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      {room.door_open ? (
                                        <MeetingRoomIcon
                                          className={classes.flashingIcon}
                                          style={{
                                            color: "#bb2124",
                                          }}
                                        />
                                      ) : (
                                        <MeetingRoomIcon
                                          style={{ color: "#ccc" }}
                                        />
                                      )}
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                              {waterleakDevicesEnabled && (
                                <Tooltip
                                  title={
                                    room.waterleak_status
                                      ? "Засечен е теч в банята"
                                      : "Не е засечен теч в банята"
                                  }
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: "1rem",
                                        backgroundColor: "#ccc",
                                        color: "black",
                                      },
                                    },
                                  }}
                                >
                                  <span>
                                    <IconButton
                                      aria-label="waterleak_status"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <OpacityIcon
                                        style={{
                                          color: room.waterleak_status
                                            ? "#1e90ff"
                                            : "#ccc",
                                        }}
                                      />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                            </Stack>
                          </CardActions>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
            )}

            {/* Dialog components remain unchanged */}
            {/* <Dialog
              open={openCard}
              onClose={handleCardClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth
            >
              {room && DialogComponent(room)}
            </Dialog>

            <Dialog
              open={openSupportCard}
              onClose={handleCardClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth
            >
              {room && SupportDialogComponent(room)}
            </Dialog> */}
          </Container>
        </Scrollbar>
      </main>
    </div>
  );
}
